import React from 'react';
import { PortalProvider } from './contexts/PortalContext';
import PortalApp from './PortalApp';

export default function App() {
    return (
        <>
            <PortalProvider>
                <style>
                    {`
                /* Default (light) */
                :root {
                    --kendo-color-on-app-surface: #000;
                    --kendo-color-primary-on-surface: #000;
                    --kendo-color-primary: #000;
                    --kendo-color-primary-hover: #3c557d;
                }

                /* Dark mode overrides (auto-applied when OS uses dark theme) */
                @media (prefers-color-scheme: dark) {
                    :root {
                        --kendo-color-on-app-surface: #fff;
                        --kendo-color-primary-on-surface: #fff;
                        --kendo-color-primary: #90caf9;
                        --kendo-color-primary-hover: #64b5f6;
                    }
                }
                `}
                </style>
                <PortalApp />
            </PortalProvider>
        </>
    );
}